<div class="capture-selfie-verificacao">
  <webcam
    [trigger]="webcamTrigger"
    [switchCamera]="nextWebcamObservable"
    [allowCameraSwitch]="false"
    (imageCapture)="handleImageCapture($event)"
    (initError)="handleErroWebcam($event)"></webcam>

  <div class="capture-selfie-verificacao_content">
    <div class="capture-selfie-verificacao_content_dica" *ngIf="hasWebcam">
      <span>Centralize seu rosto na câmera e aperte o botão para tirar a foto</span>
    </div>

    <div
      class="capture-selfie-verificacao_content_aviso"
      *ngIf="!hasWebcam && !showLoader">
      {{ textoErroWebcam }}
    </div>

    <div class="capture-selfie-verificacao_content_mask" *ngIf="hasWebcam"></div>

    <div
        class="capture-selfie-verificacao_content_btn">
      <em class="fa fa-camera"
        title="Tirar uma foto"
        (click)="onClickTirarUmaFoto()"></em>

      <em class="fa fa-refresh"
        *ngIf="!showLoader"
        title="Trocar câmera"
        (click)="goNextWebcam()"></em>
    </div>
  </div>
</div>
